<template>
  <div class="template-data-grid"
       :class="{'main-top-layout': topRoute}"
       v-loading="grid.loading"
       element-loading-text="页面加载中，请稍等...">
    <div class="data-grid-content">
      <template v-if="grid.data.config">
        <DataGridPreSearch :config="config"
                           :grid="grid"
                           :search-columns="gridSearchColumns"
                           v-bind="$attrs"
                           @search="handlePreSearch"></DataGridPreSearch>
        <div class="data-grid-layout"
             v-if="!config.preSearch">
          <el-card shadow="never" :style="getLayoutCenterStyle">
            <div slot="header" class="data-grid-header">
              <slot name="title"
                    :grid="grid"
                    :title="grid.data.config.title">
                <Tile v-if="grid.data.config.titleComponent"
                      :component-path="grid.data.config.titleComponent"
                      :grid="grid"
                      :title="grid.data.config.title"
                      v-bind="$attrs"></Tile>
                <span v-else
                      class="title"
                      v-html="grid.data.config.title"></span>
              </slot>
              <div class="search-input-group" v-if="gridSearchColumns && gridSearchColumns.length > 0">
                <template v-if="showGridSearch">
                  <div class="simple-search-wrap"
                       v-if="enableGridSimpleSearch"
                       v-show="!config.search.advanced">
                    <el-input class="simple-search-input"
                              v-model="grid.data.config.prevMatchValue"
                              v-input-trim
                              :class="{'is-active': !!grid.data.config.prevMatchValue, 'no-match': grid.search.matchProps.length === 0}"
                              :placeholder="grid.search.matchAll ? '搜索全部项' : (grid.search.matchSome ? '搜索选择项' : '没有搜索项')"
                              clearable
                              @clear="handleMatchTextClear"
                              @keyup.enter.native="handleMatchPropSearch">
                      <el-dropdown slot="prefix"
                                   placement="bottom-start"
                                   :hide-on-click="false">
                        <el-badge is-dot
                                  :hidden="grid.loading || !gridSearchPropsChange">
                          <i class="iconfont icon-shaixuan"></i>
                        </el-badge>
                        <el-dropdown-menu class="search-input-drop" slot="dropdown">
                          <div class="drop-menu-header">
                            <span>匹配项</span>
                            <el-checkbox style="float: right"
                                         :indeterminate="grid.search.matchSome"
                                         v-model="grid.search.matchAll"
                                         @change="handleMatchAllProp">全选</el-checkbox>
                          </div>
                          <AppScrollbar style="height: 100%"
                                        scroll-x>
                            <div class="drop-menu-body">
                              <el-checkbox-group v-model="grid.search.matchProps" @change="handleMatchPropChange">
                                <el-dropdown-item v-for="(column, index) in gridSearchColumns"
                                                  :key="'checkbox_column_' + index">
                                  <el-checkbox :label="column.prop">{{column.name}}</el-checkbox>
                                </el-dropdown-item>
                              </el-checkbox-group>
                            </div>
                          </AppScrollbar>
                          <div class="drop-menu-footer" v-if="gridSearchPropsChange">
                            <el-button size="mini" type="text" @click="initGridSearchProps">设置为默认</el-button>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button slot="append" @click="handleMatchPropSearch">搜索</el-button>
                    </el-input>
                  </div>
                  <template v-if="enableGridSimpleSearch">
                    <el-tooltip content="普通搜索" placement="top" :enterable="false" v-if="config.search.advanced">
                      <el-button class="search-input-item theme-text" type="text" icon="iconfont icon-putongsousuo1" @click="quitAdvancedSearch"></el-button>
                    </el-tooltip>
                    <el-tooltip content="高级搜索" placement="top" :enterable="false" v-else>
                      <el-button class="search-input-item theme-text" type="text" icon="iconfont icon-gaojisousuo" @click="toAdvancedSearch"></el-button>
                    </el-tooltip>
                  </template>
                  <template v-else>
                    <div class="search-filter-wrap">
                      <template v-if="useSubscribeSearch">
                        <DataGridSearchFilter :search-columns="gridSearchColumns"
                                              :search-filter="grid.search.propFilter"
                                              @filter-change="onSearchFilterChange">
                          <template #default="{toggleVisible}">
                            <el-button size="mini"
                                       type="text"
                                       icon="el-icon-setting"
                                       @click="toggleVisible">配置搜索列</el-button>
                          </template>
                        </DataGridSearchFilter>
                        <el-divider direction="vertical"></el-divider>
                      </template>
                      <template v-if="formSearchColumns && formSearchColumns.length">
                        <el-button size="mini"
                                   type="text"
                                   :icon="config.search.advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                                   @click="toggleAdvancedSearch">
                          <span>{{config.search.advanced ? '隐藏搜索栏' : '展示搜索栏'}}</span>
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button class="btn-warning"
                                   size="mini"
                                   type="text"
                                   icon="el-icon-warning-outline"
                                   @click="toggleAdvancedSearch">
                          <span>没有搜索列</span>
                        </el-button>
                      </template>
                    </div>
                  </template>
                </template>
                <template v-else-if="showGridFilter">
                  <div class="simple-filter-wrap">
                    <el-input class="simple-filter-input"
                              v-model="grid.data.config.filterKeyword"
                              v-input-trim
                              :class="{'is-active': !!grid.data.config.filterKeyword, 'no-match': grid.search.matchProps.length === 0}"
                              :placeholder="grid.search.matchAll ? '输入关键字...' : (grid.search.matchSome ? '选择关键字...' : '没有匹配项')"
                              clearable
                              @clear="handleMatchTextClear"
                              @keyup.enter.native="handleMatchPropSearch">
                      <el-dropdown slot="prefix"
                                   placement="bottom-start"
                                   :hide-on-click="false">
                        <el-badge is-dot
                                  :hidden="grid.loading || !gridSearchPropsChange">
                          <i class="iconfont icon-shaixuan"></i>
                        </el-badge>
                        <el-dropdown-menu class="search-input-drop" slot="dropdown">
                          <div class="drop-menu-header">
                            <span>匹配项</span>
                            <el-checkbox style="float: right"
                                         :indeterminate="grid.search.matchSome"
                                         v-model="grid.search.matchAll"
                                         @change="handleMatchAllProp">全选</el-checkbox>
                          </div>
                          <AppScrollbar style="height: 100%"
                                        scroll-x>
                            <div class="drop-menu-body">
                              <el-checkbox-group v-model="grid.search.matchProps" @change="handleMatchPropChange">
                                <el-dropdown-item v-for="(column, index) in gridSearchColumns"
                                                  :key="'checkbox_column_' + index">
                                  <el-checkbox :label="column.prop">{{column.name}}</el-checkbox>
                                </el-dropdown-item>
                              </el-checkbox-group>
                            </div>
                          </AppScrollbar>
                          <div class="drop-menu-footer" v-if="gridSearchPropsChange">
                            <el-button size="mini" type="text" @click="initGridSearchProps">设置为默认</el-button>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-input>
                  </div>
                </template>
              </div>
            </div>
            <div class="grid-content layout-border-flex">
              <div class="grid-header layout-flex-around layout-border-flex">
                <DataGridSearchForm v-if="showGridSearch"
                                    :config="config"
                                    :grid="grid"
                                    :search-columns="formSearchColumns"
                                    :search-filter="grid.search.propFilter"
                                    :disable-complex="!complexGridSearch"
                                    v-bind="$attrs"
                                    @handleFormSearch="handleMatchMapSearch">
                </DataGridSearchForm>
                <div class="grid-top-menu layout-flex-around clearfix">
                  <DataGridFunctionMenu ref="dataGridFunctionMenu"
                                        class="grid-menu-left"
                                        :grid-data="grid.data"
                                        :grid-search="grid.search"
                                        :single-mode="!selectionMode"
                                        v-bind="$attrs"
                                        @printGridData="handlePrintGridData"
                                        @reloadGridData="loadGridData"
                                        @changeRoutePath="changeRoutePath"
                                        @clearGridSelection="clearGridSelection">
                  </DataGridFunctionMenu>
                  <div class="grid-menu-right">
                    <el-tooltip content="刷新数据" placement="top" :enterable="false">
                      <DataRefreshMenu :refreshing="grid.data.loading"
                                       @click="loadGridData"></DataRefreshMenu>
                    </el-tooltip>
                    <el-tooltip content="显示列" placement="top" :enterable="false" v-if="gridVisibleModels && gridVisibleModels.length > 0">
                      <el-dropdown placement="bottom-end"
                                   trigger="click"
                                   :hide-on-click="false">
                        <el-button class="grid-menu-item" type="text">
                          <i class="iconfont icon-xianshiziduan"></i>
                        </el-button>
                        <el-dropdown-menu class="grid-top-menu-drop" slot="dropdown">
                          <div class="drop-menu-header">
                            <span>显示列</span>
                            <el-checkbox style="float: right"
                                         :indeterminate="grid.visible.selectSome"
                                         v-model="grid.visible.selectAll"
                                         @change="handleShowAllProp">全选</el-checkbox>
                          </div>
                          <AppScrollbar style="height: 100%"
                                        scroll-x>
                            <div class="drop-menu-body">
                              <el-checkbox-group v-model="grid.visible.selectProps" @change="handleShowPropChange">
                                <el-dropdown-item v-for="model in gridVisibleModels"
                                                  :key="model.id">
                                  <el-checkbox :label="model.id">{{model.title}}</el-checkbox>
                                </el-dropdown-item>
                              </el-checkbox-group>
                            </div>
                          </AppScrollbar>
                          <div class="drop-menu-footer" v-if="gridVisibleSetup">
                            <el-button size="mini" type="text" @click="clearStorageVisible">设置为默认</el-button>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-tooltip>
                    <el-tooltip content="冻结列" placement="top" :enterable="false" v-if="gridFixableModels && gridFixableModels.length > 0">
                      <el-dropdown placement="bottom-end"
                                   trigger="click"
                                   :hide-on-click="false">
                        <el-button class="grid-menu-item" type="text">
                          <i class="iconfont icon-dongjielie"></i>
                        </el-button>
                        <el-dropdown-menu class="grid-top-menu-drop" slot="dropdown">
                          <div class="drop-menu-header">
                            <span>冻结列</span>
                          </div>
                          <AppScrollbar style="height: 100%"
                                        scroll-x>
                            <div class="drop-menu-body">
                              <el-checkbox-group v-model="grid.fixable.fixedProps" @change="handleFixedPropChange">
                                <el-dropdown-item v-for="model in gridFixableModels"
                                                  :key="model.id">
                                  <div class="menu-config-item">
                                    <el-checkbox :label="model.id">{{model.title}}</el-checkbox>
                                    <div class="option-wrapper"
                                         :class="{'visibility-hidden': !grid.fixable.fixedProps.includes(model.id)}">
                                      <el-radio-group v-model="model.fixedAlign"
                                                      size="mini"
                                                      @change="handleFixedAlignChange(model)">
                                        <el-radio-button label="left">
                                          <i class="el-icon-arrow-left"></i>
                                        </el-radio-button>
                                        <el-radio-button label="right">
                                          <i class="el-icon-arrow-right"></i>
                                        </el-radio-button>
                                      </el-radio-group>
                                    </div>
                                  </div>
                                </el-dropdown-item>
                              </el-checkbox-group>
                            </div>
                          </AppScrollbar>
                          <div class="drop-menu-footer" v-if="gridFixedSetup">
                            <el-button size="mini" type="text" @click="clearStorageFixed">设置为默认</el-button>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-tooltip>
                    <el-tooltip content="表格设置" placement="top" :enterable="false">
                      <el-dropdown placement="bottom-end"
                                   trigger="click"
                                   :hide-on-click="false">
                        <el-button class="grid-menu-item" type="text">
                          <i class="iconfont icon-shezhi"></i>
                        </el-button>
                        <el-dropdown-menu class="grid-top-menu-drop is-wide" slot="dropdown">
                          <div class="drop-menu-header">
                            <span>表格设置</span>
                          </div>
                          <div class="drop-menu-body">
                            <div class="menu-config-list">
                              <div class="menu-config-item">
                                <span>显示列</span>
                                <el-button size="mini"
                                           type="primary"
                                           :disabled="!gridVisibleSetup"
                                           @click="clearStorageVisible">置为默认</el-button>
                              </div>
                              <div class="menu-config-item">
                                <span>冻结列</span>
                                <el-button size="mini"
                                           type="primary"
                                           :disabled="!gridFixedSetup"
                                           @click="clearStorageFixed">置为默认</el-button>
                              </div>
                              <div class="menu-config-item">
                                <span>列顺序</span>
                                <el-button size="mini"
                                           type="primary"
                                           :disabled="!gridOrderSetup"
                                           @click="clearStorageOrder">置为默认</el-button>
                              </div>
                            </div>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-tooltip>
                    <el-tooltip content="数据打印" placement="top" :enterable="false">
                      <el-button class="grid-menu-item" type="text" @click="gridDataPrint">
                        <i class="iconfont icon-dayin"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip content="数据导出" placement="top" :enterable="false" v-if="grid.data.config.exportConfig && grid.data.config.exportConfig.length > 0">
                      <el-button class="grid-menu-item" type="text" @click="gridDataExport">
                        <i class="iconfont icon-daochu"></i>
                      </el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="grid-body layout-flex-center">
                <DataGridWrapper :grid-config="grid.data.config"
                                 :row-list="gridDataList">
                  <template slot-scope="{rowClassName}">
                    <DataGrid ref="dataGridTable"
                              :data="gridDataList"
                              :position-resolver="grid.searchParams"
                              style="width: 100%"
                              height="100%"
                              :size="gridConfig.size"
                              :border="gridConfig.border"
                              :stripe="gridConfig.stripe"
                              highlight-current-row
                              highlight-hover-row
                              highlight-hover-column
                              highlight-current-column
                              show-overflow="title"
                              show-header-overflow="title"
                              resizable
                              :fit="gridConfig.fit"
                              :loading="grid.data.loading"
                              :row-class-name="rowClassName"
                              :show-footer="!!grid.data.config.aggregations"
                              :footer-method="buildAggregation"
                              :footer-row-class-name="buildFooterClassName"
                              :footer-cell-class-name="buildAggregationClassName"
                              row-id="id"
                              column-key
                              :checkbox-config="gridCheckboxConfig"
                              :sort-config="gridSortConfig"
                              @cell-click="gridRowClick"
                              @cell-dblclick="gridRowDoubleClick"
                              @current-change="gridCurrentSelectionChange"
                              @checkbox-change="gridSelectionChange"
                              @checkbox-all="gridSelectionChange"
                              @sort-change="gridColumnSortChange"
                              @column-reorder="saveStorageOrder">
                      <DataGridIdColumn :selection-mode="selectionMode"
                                        :page-index="grid.data.config.pageIndex"
                                        :page-size="grid.data.config.pageSize"></DataGridIdColumn>
                      <CompositeTableColumn v-for="(column, index) in grid.data.config.columns"
                                            :key="'column_' + index"
                                            :table-column="column"
                                            :table-column-cell-render="tableColumnCellRender"
                                            v-bind="$attrs"
                                            @reloadGridData="loadGridData"
                                            @changeRoutePath="changeRoutePath"
                                            @updateGridRow="handleUpdateRow">
                      </CompositeTableColumn>
                      <div slot="empty" v-show="!grid.data.loading">
                        <div v-if="gridDataList">
                          <span>未查询到任何数据</span>
                        </div>
                        <div v-else>
                          <span class="grid-data-load-failed">表格数据加载失败<a class="theme-text" href="javascript:;" @click="loadGridData">重新加载</a></span>
                        </div>
                      </div>
                    </DataGrid>
                  </template>
                </DataGridWrapper>
              </div>
              <div class="grid-footer layout-flex-around">
                <el-pagination
                  :page-sizes="grid.search.pageSizes"
                  :page-size.sync="grid.data.config.pageSize"
                  :current-page.sync="grid.data.config.pageIndex"
                  :total="grid.data.totalCount"
                  :pager-count="grid.search.pagerCount"
                  :layout="paginationLayout"
                  @size-change="paginationPageSizeChange"
                  @current-change="paginationPageChange">
                  <template v-if="grid.data.raw">
                    <template v-if="grid.data.raw.optimizePage">
                      <span class="custom optimize">
                        <el-tooltip content="显示的条数不代表记录的总条数">
                          <i class="el-icon-warning-outline"></i>
                        </el-tooltip>
                        <span v-if="grid.data.raw.optimizePageHidden">没有列出全部页数</span>
                        <span v-else>最多显示 {{grid.data.totalCount}} 条</span>
                      </span>
                    </template>
                    <template v-else>
                      <span class="custom">共 {{grid.data.totalCount}} 条</span>
                    </template>
                  </template>
                </el-pagination>
              </div>
            </div>
          </el-card>
          <div class="data-grid-border layout-animate" v-if="grid.data.config.composite" :style="getLayoutBorderStyle">
            <DataGridComposite :component-path="grid.data.config.composite.component"
                               :grid-data="grid.data"
                               :grid-search="grid.search"
                               :table-column-cell-render="tableColumnCellRender"
                               v-bind="$attrs"
                               @showCompositeLayout="showCompositeLayout"
                               @hideCompositeLayout="hideCompositeLayout"
                               @clearGridCurrentRow="clearGridCurrentRow"
                               @reloadGridData="loadGridData"
                               @changeRoutePath="changeRoutePath"
                               @updateGridRow="handleUpdateRow">
            </DataGridComposite>
          </div>
        </div>
      </template>
      <template v-else>
        <Hint class="grid-load-failed" :icon="false" v-if="!grid.loading">
          <span>页面加载失败</span>
          <div class="button-group">
            <el-button type="primary" size="mini" plain @click="loadInitGridData">点击重试</el-button>
          </div>
        </Hint>
      </template>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { getValueByPath } from 'element-ui/lib/utils/util'
import baseApiUrl from '../../constants/baseApiUrl'
import globalEvent from '../../constants/globalEvent'
import routeConfig from '../../constants/routeConfig'
import regexUtils from '../../util/regexUtils'
import storageUtils from '../../util/storageUtils'
import objectUtils from '../../util/objectUtils'
import layoutConstants from '../../constants/layoutConstants'
import conditionEnum from '../../constants/conditionEnum'
import Support from '../../mixins/support'
import DataGridSearchFilter from '../elements/grid/DataGridSearchFilter'
import DataGridSearchForm from '../elements/grid/DataGridSearchForm'
import DataRefreshMenu from '../elements/DataRefreshMenu'
import DataGrid from '../elements/DataGrid'
import DataGridWrapper from '../elements/grid/DataGridWrapper'
import DataGridIdColumn from '../elements/grid/DataGridIdColumn'
import CompositeTableColumn from '../elements/grid/CompositeTableColumn'
import DataGridFunctionMenu from '../elements/grid/DataGridFunctionMenu'
import DataGridComposite from '../elements/grid/DataGridComposite'
import DataGridPreSearch from '../elements/grid/DataGridPreSearch'
import AppScrollbar from '../elements/AppScrollbar'
import Tile from '../elements/Tile'
import Hint from '../elements/Hint'
import inputTrim from '../../directive/inputTrim'
export default {
  mixins: [Support],
  inject: {
    $fragment: {
      default: null
    }
  },
  name: 'TemplateDataGrid',
  components: {
    DataGridSearchFilter,
    DataGridSearchForm,
    DataRefreshMenu,
    DataGrid,
    DataGridWrapper,
    DataGridIdColumn,
    CompositeTableColumn,
    DataGridFunctionMenu,
    DataGridComposite,
    DataGridPreSearch,
    AppScrollbar,
    Tile,
    Hint
  },
  directives: {inputTrim},
  props: {
    disableRestore: Boolean
  },
  provide () {
    return {
      $grid: this
    }
  },
  data () {
    return {
      config: {
        preSearch: false,
        search: {
          advanced: false
        },
        composite: {
          expanded: false
        },
        datetimePicker: {
          pickerOptions: {
            shortcuts: [{
              text: '本周',
              onClick (picker) {
                const now = new Date()
                const start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                let n = start.getDay()
                if (n === 0) {
                  n = 7
                }
                start.setDate(start.getDate() - n + 1)
                const end = new Date(start.getTime() + 3600 * 1000 * 24 * 7 - 1000)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '上周',
              onClick (picker) {
                const now = new Date()
                const start = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                start.setDate(start.getDate() - 7)
                let n = start.getDay()
                if (n === 0) {
                  n = 7
                }
                start.setDate(start.getDate() - n + 1)
                const end = new Date(start.getTime() + 3600 * 1000 * 24 * 7 - 1000)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '本月',
              onClick (picker) {
                const now = new Date()
                const start = new Date(now.getFullYear(), now.getMonth(), 1)
                const end = new Date(now.getFullYear(), now.getMonth() + 1, 1, 23, 59, 59)
                end.setDate(end.getDate() - 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '上月',
              onClick (picker) {
                let now = new Date()
                now = new Date(now.getFullYear(), now.getMonth() - 1, 1)
                const start = new Date(now.getFullYear(), now.getMonth(), 1)
                const end = new Date(now.getFullYear(), now.getMonth() + 1, 1, 23, 59, 59)
                end.setDate(end.getDate() - 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '本年',
              onClick (picker) {
                const now = new Date()
                const start = new Date(now.getFullYear(), 0, 1)
                const end = new Date(now.getFullYear() + 1, 0, 1, 23, 59, 59)
                end.setDate(end.getDate() - 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '上年',
              onClick (picker) {
                let now = new Date()
                now = new Date(now.getFullYear() - 1, 0, 1)
                const start = new Date(now.getFullYear(), 0, 1)
                const end = new Date(now.getFullYear() + 1, 0, 1, 23, 59, 59)
                end.setDate(end.getDate() - 1)
                picker.$emit('pick', [start, end])
              }
            }]
          }
        }
      },
      grid: {
        loading: false,
        loaded: false,
        search: {
          propFilter: {},
          matchSome: false,
          matchAll: false,
          matchProps: [],
          matchMap: null,
          pageSizes: [10, 20, 50, 100],
          pagerCount: 5,
          currentParams: null
        },
        searchParams: null,
        visible: {
          selectSome: false,
          selectAll: false,
          selectProps: []
        },
        fixable: {
          fixedProps: []
        },
        data: {
          config: null,
          loading: false,
          columnModels: [],
          raw: null,
          rowList: [],
          totalCount: 0,
          aggregation: null,
          rowSelection: [],
          currentRow: null
        }
      },
      storage: {
        column: {
          visible: null,
          fixed: null,
          order: null
        },
        sort: null
      }
    }
  },
  computed: {
    ...mapState({
      accountObj: state => state.account,
      gridConfig: state => state.grid.config
    }),
    // 表格ID
    gridId: function () {
      return `${this.accountObj.loginId || '_anonymous'}$$grid_${this.$attrs[routeConfig.DataGrid.param]}`
    },
    // 表格选择
    gridCheckboxConfig: function () {
      return {
        highlight: true
      }
    },
    // 表格排序
    gridSortConfig: function () {
      if (this.grid.data.config) {
        let remoteSort
        if (!this.grid.data.raw || this.grid.data.raw.disabledSort) {
          remoteSort = false
        } else {
          remoteSort = true
        }
        let sortConfig = {
          trigger: 'default',
          remote: remoteSort
        }
        if (this.grid.data.config.sort) {
          sortConfig.defaultSort = {
            field: this.grid.data.config.sort.prop,
            order: this.grid.data.config.sort.type
          }
        }
        return sortConfig
      }
    },
    // 是否展示搜索
    showGridSearch: function () {
      return this.grid.data.raw && !this.grid.data.raw.disabledSearch
    },
    // 是否展示筛选
    showGridFilter: function () {
      return this.grid.data.raw && this.grid.data.raw.disabledSearch
    },
    // 是否启用极简搜索
    enableGridSimpleSearch: function () {
      return this.complexGridSearch && !this.onlyAdvancedSearch
    },
    // 是否使用复杂搜索
    complexGridSearch: function () {
      if (!this.grid.data.raw || this.grid.data.raw.disabledComplexSearch) {
        return false
      }
      return true
    },
    // 只展示高级搜索
    onlyAdvancedSearch: function () {
      if (this.useSubscribeSearch) {
        return true
      }
      if (this.grid.data.config) {
        return this.grid.data.config.searchStrategy === 'only_advanced'
      }
    },
    // 只使用订阅搜索
    useSubscribeSearch: function () {
      if (this.grid.data.config) {
        return this.grid.data.config.searchStrategy === 'only_subscribe'
      }
    },
    // 表格搜索列
    gridSearchColumns: function () {
      let columns = this.grid.data.config ? this.grid.data.config.columns : null
      if (columns) {
        let searchColumns = []
        columns.forEach((column, index) => {
          this.computeSearchColumn(column, searchColumns)
        })
        return searchColumns
      } else {
        return null
      }
    },
    // 展示搜索列
    formSearchColumns () {
      const gridSearchColumns = this.gridSearchColumns || []
      if (this.useSubscribeSearch) {
        return gridSearchColumns.filter(column => !!this.grid.search.propFilter[column.prop])
      }
      return gridSearchColumns
    },
    // 普通搜索变化
    gridSearchPropsChange: function () {
      let props = this.getAllMatchProps()
      let matchProps = this.grid.search.matchProps
      if (props.length !== matchProps.length) {
        return true
      }
      return props.some(prop => !matchProps.includes(prop))
    },
    // 表格显示列模型
    gridVisibleModels: function () {
      let models = this.grid.data.columnModels
      if (models) {
        return models.filter(model => !!model.property)
      }
    },
    // 表格固定列模型
    gridFixableModels: function () {
      let models = this.grid.data.columnModels
      if (models) {
        return models.filter(model => !!model.property && model.level === 1)
      }
    },
    // 配置了显示列
    gridVisibleSetup: function () {
      let visible = this.storage.column.visible
      return visible && Object.keys(visible).length
    },
    // 配置了冻结列
    gridFixedSetup: function () {
      let fixed = this.storage.column.fixed
      return fixed && Object.keys(fixed).length
    },
    // 配置了列顺序
    gridOrderSetup: function () {
      let order = this.storage.column.order
      return order && order.length
    },
    // 是否是选择模式
    selectionMode: function () {
      if (this.grid.data.config) {
        return this.grid.data.config.isSelectionMode
      }
      return false
    },
    // 页码布局
    paginationLayout: function () {
      if (!this.grid.data.raw || this.grid.data.raw.disabledPagination) {
        return '->, total'
      }
      return 'jumper, prev, pager, next, ->, slot, sizes'
    },
    // 展示数据
    gridDataList: function () {
      const rowList = this.grid.data.rowList
      const filterKeyword = this.grid.data.config.filterKeyword
      if (filterKeyword) {
        const matchProps = this.grid.search.matchProps
        if (matchProps.length) {
          return rowList.filter(row => {
            return matchProps.some(prop => {
              const value = getValueByPath(row, prop)
              return `${value}`.includes(filterKeyword)
            })
          })
        }
      }
      return rowList
    },
    // 中间面板样式
    getLayoutCenterStyle: function () {
      if (this.grid.data.config && this.grid.data.config.composite) {
        const size = this.grid.data.config.composite.size || 300
        return {
          [this.grid.data.config.composite.position]: this.config.composite.expanded ? `${size + 10}px` : 0
        }
      } else {
        return null
      }
    },
    // 边缘面板样式
    getLayoutBorderStyle: function () {
      if (this.grid.data.config && this.grid.data.config.composite) {
        const size = this.grid.data.config.composite.size || 300
        switch (this.grid.data.config.composite.position) {
          case 'left':
          case 'right': {
            return {
              width: `${size}px`,
              height: '100%',
              [this.grid.data.config.composite.position]: this.config.composite.expanded ? 0 : `${-size}px`
            }
          }
          case 'top':
          case 'bottom': {
            return {
              width: '100%',
              height: `${size}px`,
              [this.grid.data.config.composite.position]: this.config.composite.expanded ? 0 : `${-size}px`
            }
          }
        }
      }
      return null
    },
    // 默认单击行为
    getRowClickBehavior: function () {
      if (this.grid.data.config && this.grid.data.config.columns) {
        return this.grid.data.config.columns.find(column => {
          let renderAction = column['renderAction']
          if (renderAction) {
            let behaviorType = renderAction['behaviorType']
            if (behaviorType) {
              return behaviorType === 'ROW_CLICK'
            }
          }
        })
      }
      return null
    },
    // 默认双击行为
    getRowDblclickBehavior: function () {
      if (this.grid.data.config && this.grid.data.config.columns) {
        return this.grid.data.config.columns.find(column => {
          let renderAction = column['renderAction']
          if (renderAction) {
            let behaviorType = renderAction['behaviorType']
            if (behaviorType) {
              return behaviorType === 'ROW_DBLCLICK'
            }
          }
        })
      }
      return null
    }
  },
  methods: {
    // 初始化配置信息
    initColumnConfig (columns) {
      if (columns) {
        let matchMap = {}
        columns.forEach((column, index) => {
          this.computeInitColumn(column, matchMap)
        })
        this.grid.search.matchMap = matchMap
      }
    },
    // 初始化列
    computeInitColumn (column, matchMap) {
      let childColumns = column['childColumns']
      if (childColumns && childColumns.length > 0) {
        childColumns.forEach((c, i) => {
          this.computeInitColumn(c, matchMap)
        })
      } else {
        // 屏蔽prop中的.引起的问题
        column._prop = column.prop.replace(new RegExp('\\.', 'g'), '_')
        if (column['isListable']) {
          // 搜索信息
          let inputConfig = column['inputConfig']
          let prevSearchValue = column['prevSearchValue']
          let initDataVal
          if (inputConfig) {
            let elementType = inputConfig.elementType
            if (elementType === 'DATE_FIELD' || elementType === 'DATETIME_FIELD' || elementType === 'CUSTOM_DATE_FIELD') {
              if (prevSearchValue && prevSearchValue.length > 1) {
                initDataVal = []
                initDataVal.push(prevSearchValue[0])
                initDataVal.push(prevSearchValue[1])
              } else {
                initDataVal = ''
              }
            } else if (elementType === 'DROP_DOWN_SELECT_LIST' || elementType === 'DROP_DOWN_SELECT_PAGE' || elementType === 'CASCADER_SELECT') {
              initDataVal = prevSearchValue || []
            } else {
              if (prevSearchValue) {
                initDataVal = prevSearchValue.length > 0 ? prevSearchValue[0] : ''
              } else {
                initDataVal = ''
              }
            }
          } else {
            if (prevSearchValue) {
              initDataVal = prevSearchValue.length > 0 ? prevSearchValue[0] : ''
            } else {
              initDataVal = ''
            }
          }
          matchMap[column._prop] = {
            key: column.prop,
            value: initDataVal,
            condition: column['prevMatchMode'] || ''
          }
        }
      }
    },
    // 获取搜索列
    computeSearchColumn (column, searchColumns) {
      let childColumns = column['childColumns']
      if (childColumns && childColumns.length > 0) {
        childColumns.forEach((c, i) => {
          this.computeSearchColumn(c, searchColumns)
        })
      } else {
        if (column['isListable'] && column['isSearchable']) {
          searchColumns.push(column)
        }
      }
    },
    // 获取所有匹配信息
    getAllMatchProps () {
      let matchProps = []
      let gridSearchColumns = this.gridSearchColumns
      if (gridSearchColumns) {
        gridSearchColumns.forEach((column, index) => {
          if (column['isPrevMatch']) {
            matchProps.push(column.prop)
          }
        })
      }
      return matchProps
    },
    // 点击全选
    handleMatchAllProp (val) {
      let gridSearchColumns = this.gridSearchColumns
      if (gridSearchColumns) {
        if (val) {
          this.grid.search.matchProps = gridSearchColumns.map(column => column.prop)
        } else {
          this.grid.search.matchProps = []
        }
        this.grid.search.matchSome = false
      }
    },
    // 匹配变化
    handleMatchPropChange (val) {
      let gridSearchColumns = this.gridSearchColumns
      if (gridSearchColumns) {
        let checkedCount = val.length
        if (checkedCount === gridSearchColumns.length) {
          this.grid.search.matchAll = true
          this.grid.search.matchSome = false
        } else {
          this.grid.search.matchAll = false
          this.grid.search.matchSome = checkedCount > 0
        }
      }
    },
    // 点击全选
    handleShowAllProp (val) {
      let gridVisibleModels = this.gridVisibleModels
      if (gridVisibleModels) {
        if (val) {
          this.grid.visible.selectProps = gridVisibleModels.map(model => model.id)
        } else {
          this.grid.visible.selectProps = []
        }
        this.grid.visible.selectSome = false
        gridVisibleModels.forEach(model => {
          model.visible = val
        })
        this.refreshGridColumn()
      }
      this.saveStorageVisible()
    },
    // 匹配变化
    handleShowPropChange (val, init) {
      let gridVisibleModels = this.gridVisibleModels
      if (gridVisibleModels) {
        let checkedCount = val.length
        if (checkedCount === gridVisibleModels.length) {
          this.grid.visible.selectAll = true
          this.grid.visible.selectSome = false
        } else {
          this.grid.visible.selectAll = false
          this.grid.visible.selectSome = checkedCount > 0
        }
        gridVisibleModels.forEach(model => {
          model.visible = val.includes(model.id)
        })
        this.refreshGridColumn()
      }
      if (!init) {
        this.saveStorageVisible()
      }
    },
    // 匹配变化
    handleFixedPropChange (val, init) {
      let gridFixableModels = this.gridFixableModels
      if (gridFixableModels) {
        gridFixableModels.forEach(model => {
          if (val.includes(model.id)) {
            model.fixed = model.fixedAlign
          } else {
            model.fixed = ''
          }
        })
        this.refreshGridColumn()
      }
      if (!init) {
        this.saveStorageFixed()
      }
    },
    // 切换位置
    handleFixedAlignChange (column) {
      column.fixed = column.fixedAlign
      this.refreshGridColumn()
      this.saveStorageFixed()
    },
    // 单元格渲染方法
    tableColumnCellRender (row, prop, cellValue) {
      if (objectUtils.hasValue(cellValue)) {
        if (typeof cellValue !== 'string') {
          cellValue = cellValue.toString()
        }
        let currentParams = this.grid.search.currentParams
        if (currentParams) {
          if (currentParams.matchParams) {
            // 极简搜索
            let matchValue = currentParams.matchParams.value
            let matchProps = currentParams.matchParams.props
            if (matchValue && matchProps) {
              if (matchProps.includes(prop)) {
                return cellValue.replace(new RegExp(regexUtils.escapeRegExp(matchValue), 'gi'), '<span class="highlight">$&</span>')
              } else {
                return cellValue
              }
            } else {
              return cellValue
            }
          } else if (currentParams.matchMap) {
            // 高级搜索
            for (let matchKey of Object.keys(currentParams.matchMap)) {
              let matchKeys = matchKey.split(':')
              let matchValue = currentParams.matchMap[matchKey]
              let condition
              if (matchKeys.length > 1) {
                condition = Object.values(conditionEnum).find(c => c.name === matchKeys[1])
              }
              if (matchKeys[0] === prop && (objectUtils.hasValue(matchValue) || (condition && !condition.data))) {
                if (Array.isArray(matchValue)) {
                  if (matchValue.some(val => !!val)) {
                    return `<span class="highlight">${cellValue}</span>`
                  } else if (condition && condition.name) {
                    return `<span class="highlight">${cellValue}</span>`
                  }
                } else {
                  if (!condition || condition === conditionEnum.LIKE) {
                    return cellValue.replace(new RegExp(regexUtils.escapeRegExp(matchValue), 'gi'), '<span class="highlight">$&</span>')
                  } else {
                    if (condition.data) {
                      switch (condition) {
                        case conditionEnum.RANGE:
                        case conditionEnum.EQ:
                        case conditionEnum.OR:
                          return `<span class="highlight">${cellValue}</span>`
                        default:
                          break
                      }
                    } else {
                      return `<span class="highlight">${cellValue}</span>`
                    }
                  }
                }
              }
            }
            return cellValue
          } else {
            return cellValue
          }
        } else {
          return cellValue
        }
      } else {
        return cellValue
      }
    },
    // 高级搜索
    toAdvancedSearch () {
      this.config.search.advanced = true
    },
    // 极简搜索
    quitAdvancedSearch () {
      this.config.search.advanced = false
    },
    // 展示隐藏搜索
    toggleAdvancedSearch () {
      const formSearchColumns = this.formSearchColumns
      if (formSearchColumns && formSearchColumns.length) {
        this.config.search.advanced = !this.config.search.advanced
      } else {
        this.config.search.advanced = true
        if (this.useSubscribeSearch) {
          this.$message.warning('请先配置搜索列')
        } else {
          this.$message.warning('没有可搜索的列')
        }
      }
    },
    // 显示复合组件
    showCompositeLayout () {
      this.config.composite.expanded = true
    },
    // 隐藏复合组件
    hideCompositeLayout () {
      this.config.composite.expanded = false
    },
    // 加载搜索配置信息
    loadSearchData () {
      return new Promise(resolve => {
        if (this.disableRestore) {
          resolve()
        } else {
          let configs = storageUtils.getItem(this.gridId, 'columns$search')
          if (configs) {
            resolve(configs)
          } else {
            if (layoutConstants.template.grid.search.history.remote) {
              this.$ajax({
                url: baseApiUrl.DataConfigLoadUrl,
                method: 'post',
                data: this.$qs.stringify({
                  id: this.$attrs[routeConfig.DataGrid.param],
                  type: 'search'
                }),
                disableErrorPage: true
              }).then(response => {
                resolve(response.data.configs)
              }, () => {
                resolve()
              })
            } else {
              resolve()
            }
          }
        }
      })
    },
    // 加载列配置信息
    loadColumnData () {
      this.loadStorageData().then(() => {
        this.$nextTick(() => {
          let dataGridTable = this.$refs['dataGridTable']
          if (dataGridTable) {
            let columnModels = dataGridTable.getTableColumn().fullColumn
            if (columnModels) {
              columnModels.forEach((model, index) => {
                model.$$index = index
              })
            }
            let order = this.storage.column.order
            if (Array.isArray(order) && order.length) {
              order.forEach(val => {
                let keys = val.split('|')
                if (keys.length >= 3) {
                  if (!!keys[0] && keys[1].match(/^\d+$/) && keys[2].match(/^\d+$/)) {
                    let property = keys[0]
                    let oldIndex = parseInt(keys[1])
                    let newIndex = parseInt(keys[2])
                    let columnIndex = columnModels.findIndex(model => model.$$index === oldIndex)
                    if (columnIndex >= 0 && columnIndex !== newIndex) {
                      let columnModel = columnModels[columnIndex]
                      if (columnModel && columnModel.property === property) {
                        columnModels.splice(columnIndex, 1)
                        columnModels.splice(Math.min(newIndex, columnModels.length), 0, columnModel)
                      }
                    }
                  }
                }
              })
              dataGridTable.loadColumn(columnModels)
            }
            this.grid.data.columnModels = columnModels
          }
        })
      })
      if (!this.disableRestore) {
        let sort = storageUtils.getItem(this.gridId, 'sort')
        if (sort && sort.prop) {
          if (this.grid.data.config) {
            let columns = this.grid.data.config.columns
            if (columns) {
              let column = columns.find(col => col.prop === sort.prop)
              if (column && column.isSortable && column.isListable) {
                this.grid.data.config.sort = sort
              }
            }
          }
        }
      }
    },
    // 加载本地配置信息
    loadStorageData () {
      let promises = [
        new Promise(resolve => {
          if (this.disableRestore) {
            resolve()
          } else {
            let data = storageUtils.getItem(this.gridId, 'columns$visible')
            if (data) {
              resolve(data)
            } else {
              if (layoutConstants.template.grid.column.visible.remote) {
                this.$ajax({
                  url: baseApiUrl.DataConfigLoadUrl,
                  method: 'post',
                  data: this.$qs.stringify({
                    id: this.$attrs[routeConfig.DataGrid.param],
                    type: 'visible'
                  }),
                  disableErrorPage: true
                }).then(response => {
                  resolve(response.data.configs)
                }, () => {
                  resolve()
                })
              } else {
                resolve()
              }
            }
          }
        }),
        new Promise(resolve => {
          if (this.disableRestore) {
            resolve()
          } else {
            let data = storageUtils.getItem(this.gridId, 'columns$fixed')
            if (data) {
              resolve(data)
            } else {
              if (layoutConstants.template.grid.column.fixed.remote) {
                this.$ajax({
                  url: baseApiUrl.DataConfigLoadUrl,
                  method: 'post',
                  data: this.$qs.stringify({
                    id: this.$attrs[routeConfig.DataGrid.param],
                    type: 'fixed'
                  }),
                  disableErrorPage: true
                }).then(response => {
                  resolve(response.data.configs)
                }, () => {
                  resolve()
                })
              } else {
                resolve()
              }
            }
          }
        }),
        new Promise(resolve => {
          if (this.disableRestore) {
            resolve()
          } else {
            let data = storageUtils.getItem(this.gridId, 'columns$order')
            if (data) {
              resolve(data)
            } else {
              if (layoutConstants.template.grid.column.order.remote) {
                this.$ajax({
                  url: baseApiUrl.DataConfigLoadUrl,
                  method: 'post',
                  data: this.$qs.stringify({
                    id: this.$attrs[routeConfig.DataGrid.param],
                    type: 'order'
                  }),
                  disableErrorPage: true
                }).then(response => {
                  resolve(response.data.configs)
                }, () => {
                  resolve()
                })
              } else {
                resolve()
              }
            }
          }
        })
      ]
      return Promise.all(promises).then(([data1, data2, data3]) => {
        this.storage.column.visible = data1 || {}
        this.storage.column.fixed = data2 || {}
        this.storage.column.order = data3 || []
      })
    },
    // 加载表格配置信息
    loadInitGridData () {
      if (!this.grid.loading) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        this.grid.loading = true
        this.$ajax({
          url: baseApiUrl.DataGridUrl,
          method: 'post',
          data: this.$qs.stringify(postParams, {
            arrayFormat: 'repeat'
          })
        }).then((response) => {
          // 初始化配置
          let columns = response.data['columns']
          this.initColumnConfig(columns)
          // 设置配置
          this.grid.data.config = response.data
          // 搜索数据
          this.loadSearchData()
            .then(configs => this.handleInitSearch(configs))
            .finally(() => {
              if (this.grid.data.config.isPreSearch) {
                this.$nextTick(() => {
                  this.config.preSearch = true
                })
              } else {
                this.handleInitGrid()
              }
            })
        }).finally(() => {
          this.grid.loading = false
          this.grid.loaded = true
        })
      }
    },
    // 初始化表格配置
    handleInitGrid () {
      // 列
      this.loadColumnData()
      this.$nextTick(() => {
        if (this.useSubscribeSearch) {
          if (!this.disableRestore) {
            const propFilter = storageUtils.getItem(this.gridId, 'grid$search-filter')
            if (propFilter) {
              Object.keys(propFilter).forEach(key => {
                if (typeof this.grid.search.propFilter[key] !== 'undefined') {
                  this.grid.search.propFilter[key] = propFilter[key]
                }
              })
            }
          }
          this.handleMatchMapSearch()
        } else {
          if (this.config.search.advanced) {
            this.handleMatchMapSearch()
          } else {
            this.handleMatchPropSearch()
          }
        }
      })
    },
    // 加载表格数据
    loadGridData (configs) {
      if (!this.grid.data.config) {
        this.loadInitGridData()
        return
      }
      if (!this.grid.data.loading) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        if (configs) {
          this.grid.data.config.pageIndex = 1
        }
        this.grid.data.loading = true
        this.$nextTick(() => {
          this.grid.searchParams = JSON.stringify(this.$extend({
            pageIndex: this.grid.data.config.pageIndex,
            pageSize: this.grid.data.config.pageSize
          }, {
            sort: this.grid.data.config.sort
          }, configs || this.grid.search.currentParams))
          let params = this.$extend({
            requestType: 'list',
            searchParams: this.grid.searchParams
          }, postParams)
          this.$ajax({
            url: baseApiUrl.DataGridUrl,
            method: 'post',
            data: this.$qs.stringify(params, {
              arrayFormat: 'repeat'
            })
          }).then((response) => {
            if (configs) {
              this.grid.search.currentParams = configs
            }
            this.grid.data.raw = response.data
            this.grid.data.rowList = response.data['dataList'] || []
            this.grid.data.totalCount = response.data['totalCount'] || 0
            this.grid.data.aggregation = response.data['aggregation']
            // 数据加载完毕
            this.$bus.$emit(`${globalEvent.templateGrid.DATA_LOAD}:${this.$attrs[routeConfig.DataGrid.param]}`, this.grid.data)
            if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
              this.$message.error('列表数据加载出错')
            }
          }, () => {
            if (configs) {
              this.grid.search.currentParams = configs
            }
          }).finally(() => {
            this.grid.data.loading = false
          })
        })
      }
    },
    buildAggregation: function ({columns}) {
      let aggregations = this.grid.data.config.aggregations
      if (aggregations && aggregations.length) {
        let aggregation = this.grid.data.aggregation
        return aggregations.map(row => {
          return columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return row.name
            } else {
              if (column.own && column.own.$attrs.aggregation) {
                let field = aggregation ? aggregation[row.alias + column.property] : null
                return field ? field.value : null
              } else {
                return null
              }
            }
          })
        })
      }
      return []
    },
    buildFooterClassName: function ({$rowIndex}) {
      if ($rowIndex % 2 === 0) {
        return 'grid-footer-even-row'
      }
    },
    buildAggregationClassName: function ({$rowIndex, $columnIndex, column}) {
      if ($columnIndex === 0) {
        return 'grid-footer-cell-label theme-light-bg theme-text theme-border'
      } else {
        let cellClassNames = []
        if (!this.gridConfig.border) {
          cellClassNames.push('grid-footer-cell-divider')
        }
        let aggregations = this.grid.data.config.aggregations
        if (aggregations && aggregations.length) {
          let row = aggregations[$rowIndex]
          if (row) {
            if (column.own && column.own.$attrs.aggregation) {
              let aggregation = this.grid.data.aggregation
              let field = aggregation ? aggregation[row.alias + column.property] : null
              if (field) {
                let textTheme = field.textTheme
                if (textTheme) {
                  cellClassNames.push(`grid-footer-cell-text-${textTheme}`)
                }
                let backgroundTheme = field.backgroundTheme
                if (backgroundTheme) {
                  cellClassNames.push(`grid-footer-cell-background-${backgroundTheme}`)
                }
              }
            }
          }
        }
        return cellClassNames.join(' ')
      }
    },
    // 表格行被点击
    gridRowClick ({row}) {
      let behavior = this.getRowClickBehavior
      if (behavior) {
        this.$bus.$emit(`${globalEvent.templateGrid.ROW_CLICK}:${this.$attrs[routeConfig.DataGrid.param]}:${getValueByPath(row, 'id')}`, behavior)
      }
    },
    // 表格行被双击
    gridRowDoubleClick ({row}) {
      let behavior = this.getRowDblclickBehavior
      if (behavior) {
        this.$bus.$emit(`${globalEvent.templateGrid.ROW_DBLCLICK}:${this.$attrs[routeConfig.DataGrid.param]}:${getValueByPath(row, 'id')}`, behavior)
      } else {
        this.handleUpdateRow(row)
      }
    },
    // 编辑选定行
    handleUpdateRow (row) {
      let dataGridFunctionMenu = this.$refs['dataGridFunctionMenu']
      if (dataGridFunctionMenu) {
        dataGridFunctionMenu.handleUpdateData(row)
      } else {
        this.$notify({
          title: '操作错误',
          message: '请等待组件初始化完毕',
          type: 'error'
        })
      }
    },
    // 单选变化
    gridCurrentSelectionChange ({row}) {
      this.grid.data.currentRow = row
      if (!this.selectionMode) {
        this.grid.data.rowSelection = row ? [row] : []
      }
    },
    // 表格选择改变
    gridSelectionChange ({selection}) {
      this.grid.data.rowSelection = selection
    },
    // 重置搜索列
    initGridSearchProps () {
      if (this.useSubscribeSearch) {
        let propFilter = {}
        let gridSearchColumns = this.gridSearchColumns
        if (gridSearchColumns) {
          gridSearchColumns.forEach(column => {
            propFilter[column.prop] = !!column['isSearchFilter']
          })
        }
        this.grid.search.propFilter = propFilter
      } else {
        this.grid.search.matchProps = this.getAllMatchProps()
        this.handleMatchPropChange(this.grid.search.matchProps)
      }
    },
    // 保存本地显示隐藏配置
    saveStorageVisible () {
      let gridVisibleModels = this.gridVisibleModels
      if (gridVisibleModels) {
        let visible = {}
        gridVisibleModels.forEach(model => {
          let own = model.own
          if (own) {
            if (model.visible !== own.visible) {
              visible[`${model.$$index + 1}_${model.property}`] = model.visible
            }
          }
        })
        this.storage.column.visible = visible
      }
    },
    // 清除本地显示隐藏配置
    clearStorageVisible () {
      let gridVisibleModels = this.gridVisibleModels
      if (gridVisibleModels) {
        let selectProps = []
        gridVisibleModels.forEach(model => {
          let own = model.own
          if (own) {
            model.visible = !!own.visible
          }
          if (model.visible) {
            selectProps.push(model.id)
          }
        })
        this.refreshGridColumn()
        this.storage.column.visible = {}
        this.grid.visible.selectProps = selectProps
        this.handleShowPropChange(this.grid.visible.selectProps, true)
      }
    },
    // 保存本地固定列配置
    saveStorageFixed () {
      let gridFixableModels = this.gridFixableModels
      if (gridFixableModels) {
        let fixed = {}
        gridFixableModels.forEach(model => {
          let own = model.own
          if (own) {
            if ((model.fixed || '') !== (own.fixed || '')) {
              fixed[`${model.$$index + 1}_${model.property}`] = model.fixed
            }
          }
        })
        this.storage.column.fixed = fixed
      }
    },
    // 清除本地固定列配置
    clearStorageFixed () {
      let gridVisibleModels = this.gridVisibleModels
      if (gridVisibleModels) {
        let fixedProps = []
        gridVisibleModels.forEach(model => {
          let own = model.own
          if (own) {
            model.fixed = own.fixed || ''
          }
          if (model.fixed) {
            fixedProps.push(model.id)
          }
          this.$set(model, 'fixedAlign', model.fixed || 'left')
        })
        this.refreshGridColumn()
        this.storage.column.fixed = {}
        this.grid.fixable.fixedProps = fixedProps
        this.handleFixedPropChange(this.grid.fixable.fixedProps, true)
      }
    },
    // 保存本地列顺序配置
    saveStorageOrder ({fullColumn}) {
      this.grid.data.columnModels = fullColumn
      let order = []
      fullColumn.forEach((model, index) => {
        if (model.property && model.$$index !== index) {
          order.push(`${model.property}|${model.$$index}|${index}`)
        }
      })
      if (order.length) {
        this.storage.column.order = order
      } else {
        this.storage.column.order = null
      }
    },
    // 清除本地列顺序配置
    clearStorageOrder () {
      let dataGridTable = this.$refs['dataGridTable']
      if (dataGridTable) {
        let columnModels = dataGridTable.getTableColumn().fullColumn
        columnModels.sort((m1, m2) => m1.$$index - m2.$$index)
        dataGridTable.loadColumn(columnModels)
        this.grid.data.columnModels = columnModels
      }
      this.storage.column.order = null
    },
    // 刷新表格列
    refreshGridColumn () {
      let dataGridTable = this.$refs['dataGridTable']
      if (dataGridTable) {
        dataGridTable.refreshColumn()
        dataGridTable.refreshScroll()
      }
    },
    // 清除选择
    clearGridSelection () {
      let dataGridTable = this.$refs['dataGridTable']
      if (dataGridTable) {
        dataGridTable.clearCheckboxRow()
        this.grid.data.rowSelection = []
      }
    },
    // 清除选中行
    clearGridCurrentRow () {
      let dataGridTable = this.$refs['dataGridTable']
      if (dataGridTable) {
        dataGridTable.clearCurrentRow()
        this.grid.data.currentRow = null
        if (!this.selectionMode) {
          this.grid.data.rowSelection = []
        }
      }
    },
    // 表格排序变化
    gridColumnSortChange ({column, property, order}) {
      if (this.grid.data.config.sort) {
        this.grid.data.config.sort.prop = property
        this.grid.data.config.sort.type = order
      } else {
        this.grid.data.config.sort = {
          prop: property,
          type: order
        }
      }
      this.storage.sort = this.$extend(this.grid.data.config.sort)
      if (!this.grid.data.raw || this.grid.data.raw.disabledSort) {
        return
      }
      this.loadGridData()
    },
    // 表格数据导出
    gridDataExport () {
      if (this.grid.data.config) {
        let dataGridFunctionMenu = this.$refs['dataGridFunctionMenu']
        if (dataGridFunctionMenu) {
          dataGridFunctionMenu.handleExportData()
        } else {
          this.$notify({
            title: '操作错误',
            message: '请等待组件初始化完毕',
            type: 'error'
          })
        }
      } else {
        this.$notify({
          title: '操作错误',
          message: '获取配置信息失败',
          type: 'error'
        })
      }
    },
    // 表格数据打印
    gridDataPrint () {
      let dataGridFunctionMenu = this.$refs['dataGridFunctionMenu']
      if (dataGridFunctionMenu) {
        dataGridFunctionMenu.handlePrintData()
      } else {
        this.$notify({
          title: '操作错误',
          message: '请等待组件初始化完毕',
          type: 'error'
        })
      }
    },
    handlePrintGridData ({printHeader, scopeType, fieldType}) {
      let dataGridTable = this.$refs['dataGridTable']
      if (dataGridTable) {
        let printData
        switch (scopeType) {
          case 'selection':
            printData = this.grid.data.rowSelection
            break
          case 'all':
          default:
            printData = this.grid.data.rowList
            break
        }
        let printColumns
        let gridVisibleModels = this.gridVisibleModels
        if (gridVisibleModels) {
          printColumns = gridVisibleModels.filter(model => model.property !== 'id')
          switch (fieldType) {
            case 'all':
              break
            case 'default':
            default:
              printColumns = printColumns.filter(model => model.visible)
              break
          }
        }
        dataGridTable.printGrid({
          sheetName: this.grid.data.config.title,
          isHeader: printHeader,
          data: printData,
          columns: printColumns
        })
      }
    },
    // 分页变化
    paginationPageSizeChange (pageSize) {
      this.grid.data.config.pageSize = pageSize
      this.loadGridData()
    },
    // 分页变化
    paginationPageChange (currentPage) {
      this.grid.data.config.pageIndex = currentPage
      this.loadGridData()
    },
    // 执行预搜索
    handlePreSearch () {
      this.config.preSearch = false
      this.toAdvancedSearch()
      this.$nextTick(() => {
        this.handleInitGrid()
      })
    },
    // 极简搜索
    handleMatchPropSearch () {
      let totalProps = []
      let matchProps = []
      let gridSearchColumns = this.gridSearchColumns
      if (gridSearchColumns) {
        totalProps = gridSearchColumns.map(column => column.prop)
        matchProps = gridSearchColumns.filter(column => this.grid.search.matchProps.includes(column.prop))
          .map(column => column.prop)
      }
      this.loadGridData({
        matchParams: {
          value: this.grid.data.config['prevMatchValue'] || '',
          props: matchProps,
          refs: totalProps
        }
      })
    },
    // 清空搜索关键字
    handleMatchTextClear () {
      let currentParams = this.grid.search.currentParams
      if (currentParams && currentParams.matchParams) {
        if (currentParams.matchParams.value) {
          this.handleMatchPropSearch()
        }
      }
    },
    // 高级搜索
    handleMatchMapSearch () {
      if (this.grid.search.matchMap) {
        let matchMap = {}
        Object.keys(this.grid.search.matchMap).forEach(field => {
          let fieldItem = this.grid.search.matchMap[field]
          if (fieldItem) {
            let itemKey = fieldItem.key
            let itemValue = fieldItem.value
            let itemCondition = fieldItem.condition
            if (itemKey && (itemValue || itemCondition)) {
              if (itemCondition) {
                itemKey = `${itemKey}:${itemCondition}`
              }
              if (Array.isArray(itemValue)) {
                // 要求其中有有效的值
                if (itemValue.some(val => !!val)) {
                  matchMap[itemKey] = itemValue.concat()
                } else if (itemCondition) {
                  matchMap[itemKey] = []
                }
              } else {
                matchMap[itemKey] = itemValue
              }
            }
          }
        })
        this.loadGridData({
          matchMap: matchMap
        })
      } else {
        this.$message({
          message: '搜索配置信息不存在',
          type: 'warning',
          center: true
        })
      }
    },
    // 初始化搜索
    handleInitSearch (configs) {
      this.initGridSearchProps()
      if (configs) {
        this.config.search.advanced = false
        if (configs.matchParams) {
          let gridSearchColumns = this.gridSearchColumns
          if (gridSearchColumns) {
            let props = configs.matchParams.props
            let refs = configs.matchParams.refs || []
            if (Array.isArray(props) && Array.isArray(refs)) {
              let matchProps = gridSearchColumns
                .filter(column => props.includes(column.prop) || !refs.includes(column.prop))
                .map(column => column.prop)
              this.grid.search.matchProps = matchProps
              this.handleMatchPropChange(matchProps)
            }
            this.grid.data.config['prevMatchValue'] = configs.matchParams.value || ''
          }
        } else if (configs.matchMap) {
          this.config.search.advanced = this.grid.data.config.isExpendSearch || false
          let matchMap = this.grid.search.matchMap
          if (matchMap) {
            let useMatchMap
            Object.keys(configs.matchMap).forEach(itemKey => {
              let keys = itemKey.split(':')
              let fieldItem = Object.values(matchMap)
                .find(item => item.key === keys[0])
              if (fieldItem) {
                fieldItem.value = configs.matchMap[itemKey] || ''
                if (keys.length > 1) {
                  fieldItem.condition = keys[1]
                }
                useMatchMap = true
              }
            })
            if (useMatchMap) {
              this.config.search.advanced = true
            }
          }
          this.$nextTick(() => {
            this.grid.search.currentParams = configs
          })
        }
      } else {
        if (this.grid.data.config) {
          this.config.search.advanced = this.grid.data.config['isAdvancedSearch'] || false
        }
      }
    },
    // 搜索过滤变化
    onSearchFilterChange (propFilter) {
      this.grid.search.propFilter = propFilter || {}
      if (!this.disableRestore) {
        const propFilter = this.grid.search.propFilter
        if (propFilter) {
          storageUtils.setItem(this.gridId, 'grid$search-filter', propFilter)
        } else {
          storageUtils.removeItem(this.gridId, 'grid$search-filter')
        }
      }
      this.$nextTick(() => {
        this.config.search.advanced = true
      })
    },
    // 切换路由
    changeRoutePath (routeUrl, targetType, rowData) {
      let routeQuery = {}
      if (rowData) {
        routeQuery.postId = rowData.id
      }
      if (routeUrl.startsWith('/') || targetType === 'ROOT') {
        this.$router.push({
          path: routeUrl,
          query: routeQuery
        })
      } else {
        if (this.$fragment) {
          this.$fragment.openFragment(routeUrl, routeQuery)
        } else {
          this.$message.warning('不支持打开子页面')
        }
      }
    },
    // 触发更新事件（向上层传递事件）
    triggerDataChange (changeType) {
      this.$bus.$emit(`${globalEvent.templateGrid.DATA_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`, changeType)
    }
  },
  watch: {
    'grid.data.rowList': function (rowList) {
      if (rowList) {
        this.clearGridSelection()
        let currentRow = this.grid.data.currentRow
        if (currentRow) {
          let matchedRow = rowList.find(function (data) {
            return currentRow.id === data.id
          })
          if (matchedRow) {
            this.grid.data.currentRow = matchedRow
            if (!this.selectionMode) {
              this.grid.data.rowSelection = [matchedRow]
            }
          } else {
            this.clearGridCurrentRow()
          }
        }
      }
    },
    gridVisibleModels: function (models) {
      // 是否显示信息
      if (models) {
        let visible = this.storage.column.visible || {}
        let selectProps = []
        models.forEach(model => {
          if (model.property) {
            let v = visible[`${model.$$index + 1}_${model.property}`]
            if (typeof v !== 'undefined') {
              model.visible = !!v
            }
          }
          if (model.visible) {
            selectProps.push(model.id)
          }
        })
        this.grid.visible.selectProps = selectProps
        this.handleShowPropChange(this.grid.visible.selectProps, true)
      }
    },
    gridFixableModels: function (models) {
      // 是否固定信息
      if (models) {
        let fixed = this.storage.column.fixed || {}
        let fixedProps = []
        models.forEach(model => {
          if (model.property) {
            let f = fixed[`${model.$$index + 1}_${model.property}`]
            if (typeof f !== 'undefined') {
              model.fixed = f || ''
            }
          }
          if (model.fixed) {
            fixedProps.push(model.id)
          }
          this.$set(model, 'fixedAlign', model.fixed || 'left')
        })
        this.grid.fixable.fixedProps = fixedProps
        this.handleFixedPropChange(this.grid.fixable.fixedProps, true)
      }
    },
    gridConfig: {
      handler: function () {
        let dataGridTable = this.$refs['dataGridTable']
        if (dataGridTable) {
          this.$nextTick(() => {
            dataGridTable.recalculate()
          })
        }
      },
      deep: true
    },
    'grid.search.currentParams': function (configs) {
      if (!this.disableRestore) {
        storageUtils.setItem(this.gridId, 'columns$search', configs)
        if (layoutConstants.template.grid.search.history.remote) {
          this.$ajax({
            url: baseApiUrl.DataConfigSaveUrl,
            method: 'post',
            data: this.$qs.stringify({
              id: this.$attrs[routeConfig.DataGrid.param],
              type: 'search',
              configs: JSON.stringify(configs)
            }),
            disableErrorPage: true
          }).then(() => {}, () => {})
        }
      }
    },
    'storage.column.visible': function (val) {
      if (!this.disableRestore) {
        if (val) {
          storageUtils.setItem(this.gridId, 'columns$visible', val)
        } else {
          storageUtils.removeItem(this.gridId, 'columns$visible')
        }
        if (layoutConstants.template.grid.column.visible.remote) {
          this.$ajax({
            url: baseApiUrl.DataConfigSaveUrl,
            method: 'post',
            data: this.$qs.stringify({
              id: this.$attrs[routeConfig.DataGrid.param],
              type: 'visible',
              configs: this.gridVisibleSetup ? JSON.stringify(val) : null
            }),
            disableErrorPage: true
          }).then(() => {}, () => {})
        }
      }
    },
    'storage.column.fixed': function (val) {
      if (!this.disableRestore) {
        if (val) {
          storageUtils.setItem(this.gridId, 'columns$fixed', val)
        } else {
          storageUtils.removeItem(this.gridId, 'columns$fixed')
        }
        if (layoutConstants.template.grid.column.fixed.remote) {
          this.$ajax({
            url: baseApiUrl.DataConfigSaveUrl,
            method: 'post',
            data: this.$qs.stringify({
              id: this.$attrs[routeConfig.DataGrid.param],
              type: 'fixed',
              configs: this.gridFixedSetup ? JSON.stringify(val) : null
            }),
            disableErrorPage: true
          }).then(() => {}, () => {})
        }
      }
    },
    'storage.column.order': function (val) {
      if (!this.disableRestore) {
        if (val) {
          storageUtils.setItem(this.gridId, 'columns$order', val)
        } else {
          storageUtils.removeItem(this.gridId, 'columns$order')
        }
        if (layoutConstants.template.grid.column.order.remote) {
          this.$ajax({
            url: baseApiUrl.DataConfigSaveUrl,
            method: 'post',
            data: this.$qs.stringify({
              id: this.$attrs[routeConfig.DataGrid.param],
              type: 'order',
              configs: this.gridOrderSetup ? JSON.stringify(val) : null
            }),
            disableErrorPage: true
          }).then(() => {}, () => {})
        }
      }
    },
    'storage.sort': function (val) {
      if (!this.disableRestore) {
        if (val && val.type) {
          storageUtils.setItem(this.gridId, 'sort', val)
        } else {
          storageUtils.removeItem(this.gridId, 'sort')
        }
      }
    }
  },
  mounted () {
    this.loadInitGridData()
  },
  activated () {
    if (this.grid.loaded) {
      if (this.grid.data.config) {
        if (!this.config.preSearch) {
          this.loadGridData()
        }
      } else {
        this.loadInitGridData()
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../styles/color" as *;

  .template-data-grid {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    &.main-top-layout {
      padding: 10px;
    }
    & > .data-grid-content {
      position: relative;
      height: 100%;
      & > .data-grid-layout {
        position: relative;
        height: 100%;
        overflow: hidden;
        & > .el-card {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
          border-radius: 0;
          border: none;
          & > .el-card__header {
            position: relative;
            height: 46px;
            padding: 0 0 0 15px;
            line-height: 46px;
            background-color: #fff;
            border-bottom: none;
            .data-grid-header {
              height: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .title {
                font-size: 15px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .search-input-group {
                margin-left: 15px;
                display: flex;
                align-items: center;
                .simple-search-wrap,
                .simple-filter-wrap {
                  height: 28px;
                  line-height: 1;
                  .simple-search-input,
                  .simple-filter-input {
                    height: 100%;
                    line-height: 26px;
                    &.no-match {
                      .el-input__prefix {
                        i {
                          color: #909399;
                        }
                      }
                    }
                    .el-input__inner {
                      width: 180px;
                      height: 100%;
                      line-height: 26px;
                      vertical-align: 1px;
                      font-size: 12px;
                      padding-left: 46px;
                      border-top-left-radius: 15px;
                      border-bottom-left-radius: 15px;
                      transition: all .3s;
                      &:focus {
                        outline: none;
                        box-shadow: 0 1px 2px rgba(0,0,0,.15);
                      }
                    }
                    .el-input__prefix {
                      left: 0;
                      top: 50%;
                      width: 38px;
                      transform: translateY(-50%);
                      margin-top: 1px;
                      cursor: pointer;
                      i {
                        color: #303133;
                        width: 32px;
                        font-size: 16px;
                      }
                      .el-badge {
                        .el-badge__content {
                          &.is-dot {
                            top: 5px;
                            right: 10px;
                          }
                        }
                      }
                      &:after {
                        content: '';
                        position: absolute;
                        right: 1px;
                        top: 50%;
                        width: 1px;
                        height: 10px;
                        margin-top: -6px;
                        background-color: #ECECEC;
                      }
                    }
                    .el-input__suffix {
                      & > .el-input__suffix-inner {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                      }
                    }
                    .el-input-group__append {
                      border-top-right-radius: 15px;
                      border-bottom-right-radius: 15px;
                      padding-left: 12px;
                      padding-right: 15px;
                      .el-button {
                        font-size: 12px;
                        padding-top: 8px;
                        padding-bottom: 8px;
                        vertical-align: 1px;
                        &:active {
                          color: #606266;
                        }
                      }
                    }
                  }
                }
                .simple-filter-wrap {
                  padding-right: 15px;
                  .simple-filter-input {
                    .el-input__inner {
                      border-top-right-radius: 15px;
                      border-bottom-right-radius: 15px;
                    }
                  }
                }
                .search-input-item {
                  position: relative;
                  display: inline-block;
                  min-width: 24px;
                  height: 24px;
                  text-align: center;
                  padding: 0;
                  margin: 11px 15px;
                  & + .search-input-item {
                    margin-left: 0;
                  }
                  i {
                    font-size: 24px;
                  }
                }
                .search-filter-wrap {
                  padding-right: 15px;
                  i {
                    font-size: 14px;
                    vertical-align: -1px;
                  }
                  .btn-warning {
                    color: $set-info-color;
                  }
                }
              }
            }
          }
          & > .el-card__body {
            position: absolute;
            left: 0;
            top: 46px;
            right: 0;
            bottom: 0;
            padding: 0;
            .grid-content {
              height: 100%;
              & > .grid-header {
                position: relative;
                max-height: 100%;
                .grid-top-menu {
                  position: relative;
                  font-size: 14px;
                  background-color: #fff;
                  border-top: 1px solid #EBEEF5;
                  padding-top: 3px;
                  padding-bottom: 3px;
                  box-sizing: border-box;
                  & > .grid-menu-left {
                    float: left;
                    padding: 0 10px;
                    box-sizing: border-box;
                    &.precise-mode~ {
                      .grid-menu-right {
                        display: none;
                      }
                    }
                    .grid-menu-item {
                      margin: 7px 5px 7px 5px;
                      min-width: 40px;
                      height: 26px;
                      padding: 0 12px 0 10px;
                      &.el-button-group {
                        padding: 0;
                        .el-dropdown {
                          float: right;
                          .dropdown-caret-button {
                            position: relative;
                            width: 27px;
                            height: 26px;
                            padding: 0;
                            line-height: 26px;
                            border-left: none;
                            i {
                              margin-left: 0;
                              margin-right: 0;
                              transform: scale(.8);
                            }
                          }
                        }
                      }
                      &.el-dropdown {
                        padding: 0;
                        .el-button {
                          .el-dropdown__icon {
                            margin-left: 5px;
                            margin-right: -5px;
                            transform: scale(0.8);
                          }
                        }
                      }
                      .grid-menu-item {
                        margin: 0;
                      }
                      i {
                        margin-left: -4px;
                        font-size: 16px;
                        transform: scale(.85);
                      }
                      .text-span {
                        vertical-align: 2px;
                      }
                      &.el-button--text {
                        color: #303133;
                        padding: 0;
                      }
                      &.grid-menu-default {
                        color: $set-default-color;
                        &.is-disabled,
                        &[disabled="disabled"] {
                          opacity: .6;
                        }
                      }
                      &.grid-menu-primary {
                        color: $set-primary-color;
                        &.is-disabled,
                        &[disabled="disabled"] {
                          opacity: .6;
                        }
                      }
                      &.grid-menu-success {
                        color: $set-success-color;
                        &.is-disabled,
                        &[disabled="disabled"] {
                          opacity: .6;
                        }
                      }
                      &.grid-menu-info {
                        color: $set-info-color;
                        &.is-disabled,
                        &[disabled="disabled"] {
                          opacity: .6;
                        }
                      }
                      &.grid-menu-warning {
                        color: $set-warning-color;
                        &.is-disabled,
                        &[disabled="disabled"] {
                          opacity: .6;
                        }
                      }
                      &.grid-menu-danger {
                        color: $set-danger-color;
                        &.is-disabled,
                        &[disabled="disabled"] {
                          opacity: .6;
                        }
                      }
                    }
                  }
                  & > .grid-menu-right {
                    float: right;
                    padding-right: 10px;
                    .grid-menu-item {
                      min-width: 28px;
                      height: 40px;
                      padding: 0 5px;
                      color: #303133;
                      i {
                        font-size: 16px;
                      }
                      & + .grid-menu-item {
                        margin-left: 0;
                      }
                    }
                  }
                  & > .grid-menu-left,
                  & > .grid-menu-right {
                    .grid-menu-item {
                      position: relative;
                      text-align: center;
                      &.el-button-group {
                        vertical-align: top;
                      }
                    }
                  }
                }
              }
              & > .grid-body {
                position: relative;
                overflow: hidden;
                .vxe-table {
                  font-family: inherit!important;
                  height: 100%!important;
                  border: none!important;
                  &:before {
                    display: none;
                  }
                  .vxe-header--column {
                    .vxe-cell {
                      display: block;
                      color: #606266;
                      padding: 0;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      box-sizing: border-box;
                      .vxe-cell--title {
                        padding: 0 10px;
                        overflow: inherit;
                        white-space: inherit;
                        text-overflow: inherit;
                      }
                    }
                    &.is--sortable {
                      .vxe-cell {
                        position: relative;
                        padding-right: 20px;
                        .vxe-cell--sort {
                          position: absolute;
                          right: 5px;
                          top: 50%;
                          transform: translateY(-50%);
                          i {
                            font-size: 12px!important;
                          }
                        }
                      }
                    }
                  }
                  .vxe-body--row {
                    &.row--current,
                    &.row--hover {
                      &[class*=grid-row-] {
                        td {
                          border-bottom-color: rgba(0,0,0,.05)!important;
                          background-color: rgba(0,0,0,.05)!important;
                        }
                      }
                    }
                    &.grid-row-default {
                      background-color: $set-default-lighter-color!important;
                    }
                    &.grid-row-primary {
                      background-color: $set-primary-lighter-color!important;
                    }
                    &.grid-row-success {
                      background-color: $set-success-lighter-color!important;
                    }
                    &.grid-row-info {
                      background-color: $set-info-lighter-color!important;
                    }
                    &.grid-row-warning {
                      background-color: $set-warning-lighter-color!important;
                    }
                    &.grid-row-danger {
                      background-color: $set-danger-lighter-color!important;
                    }
                  }
                  .vxe-body--column {
                    &.col--left {
                      .vxe-cell {
                        .el-switch {
                          transform: translateX(-10%) scale(.8);
                        }
                      }
                    }
                    &.col--right {
                      .vxe-cell {
                        .el-switch {
                          transform: translateX(10%) scale(.8);
                        }
                      }
                    }
                    .vxe-cell {
                      color: #303133;
                      .highlight {
                        @extend .color-highlight;
                      }
                      .el-tag {
                        & + .el-tag {
                          margin-left: 8px;
                        }
                        &.el-tag--default {
                          @extend .color-default, .border-style;
                        }
                        &.el-tag--primary {
                          @extend .color-primary, .border-style;
                        }
                        &.el-tag--success {
                          @extend .color-success, .border-style;
                        }
                        &.el-tag--info {
                          @extend .color-info, .border-style;
                        }
                        &.el-tag--warning {
                          @extend .color-warning, .border-style;
                        }
                        &.el-tag--danger {
                          @extend .color-danger, .border-style;
                        }
                      }
                      .el-switch {
                        top: -1px;
                        transform: scale(.8);
                        &.is-disabled {
                          .el-switch__core {
                            cursor: default!important;
                          }
                        }
                      }
                      .el-rate {
                        position: relative;
                        top: 1px;
                        .el-rate__text {
                          font-size: 12px;
                        }
                      }
                      .el-progress {
                        &.el-progress--line {
                          .el-progress-bar__inner {
                            & > .el-progress-bar__innerText {
                              display: block;
                              line-height: 12px;
                              transform: scale(.9) translate(5%, -5%);
                            }
                          }
                        }
                        &.el-progress--circle {
                          top: 3px;
                          .el-progress__text {
                            font-size: 12px!important;
                            transform: scale(.9) translate(0,-50%);
                          }
                        }
                        &.progress-bar-default {
                          .el-progress-bar__inner {
                            background-color: $set-default-color;
                          }
                          path:nth-child(2) {
                            stroke: $set-default-color;
                          }
                        }
                        &.progress-bar-primary {
                          .el-progress-bar__inner {
                            background-color: $set-primary-color;
                          }
                          path:nth-child(2) {
                            stroke: $set-primary-color;
                          }
                        }
                        &.progress-bar-success {
                          .el-progress-bar__inner {
                            background-color: $set-success-color;
                          }
                          path:nth-child(2) {
                            stroke: $set-success-color;
                          }
                        }
                        &.progress-bar-info {
                          .el-progress-bar__inner {
                            background-color: $set-info-color;
                          }
                          path:nth-child(2) {
                            stroke: $set-info-color;
                          }
                        }
                        &.progress-bar-warning {
                          .el-progress-bar__inner {
                            background-color: $set-warning-color;
                          }
                          path:nth-child(2) {
                            stroke: $set-warning-color;
                          }
                        }
                        &.progress-bar-danger {
                          .el-progress-bar__inner {
                            background-color: $set-danger-color;
                          }
                          path:nth-child(2) {
                            stroke: $set-danger-color;
                          }
                        }
                      }
                      .grid-cell {
                        a,
                        button {
                          position: relative;
                          padding: 0;
                          &.action-cell {
                            text-decoration: none;
                            cursor: pointer;
                            i {
                              transform: scale(.95);
                            }
                          }
                        }
                      }
                      .grid-cell-default {
                        color: $set-default-color;
                        a,
                        button {
                          color: $set-default-color;
                        }
                      }
                      .grid-cell-primary {
                        color: $set-primary-color;
                        a,
                        button {
                          color: $set-primary-color;
                        }
                      }
                      .grid-cell-success {
                        color: $set-success-color;
                        a,
                        button {
                          color: $set-success-color;
                        }
                      }
                      .grid-cell-info {
                        color: $set-info-color;
                        a,
                        button {
                          color: $set-info-color;
                        }
                      }
                      .grid-cell-warning {
                        color: $set-warning-color;
                        a,
                        button {
                          color: $set-warning-color;
                        }
                      }
                      .grid-cell-danger {
                        color: $set-danger-color;
                        a,
                        button {
                          color: $set-danger-color;
                        }
                      }
                      .grid-cell-empty {
                        color: $set-empty-color;
                      }
                    }
                  }
                  .vxe-footer--row {
                    &.grid-footer-even-row {
                      background-color: #fefefe;
                    }
                  }
                  .vxe-footer--column {
                    &.grid-footer-cell-divider {
                      border-left: 1px dotted rgba(0,0,0,.03);
                    }
                    &.grid-footer-cell-label {
                      border-left: 1px solid;
                    }
                    &.grid-footer-cell-text-default {
                      color: $set-default-color;
                    }
                    &.grid-footer-cell-text-primary {
                      color: $set-primary-color;
                    }
                    &.grid-footer-cell-text-success {
                      color: $set-success-color;
                    }
                    &.grid-footer-cell-text-info {
                      color: $set-info-color;
                    }
                    &.grid-footer-cell-text-warning {
                      color: $set-warning-color;
                    }
                    &.grid-footer-cell-text-danger {
                      color: $set-danger-color;
                    }
                    &:not(.col--current) {
                      &.grid-footer-cell-background-default {
                        background-color: $set-default-lighter-color;
                      }
                      &.grid-footer-cell-background-primary {
                        background-color: $set-primary-lighter-color;
                      }
                      &.grid-footer-cell-background-success {
                        background-color: $set-success-lighter-color;
                      }
                      &.grid-footer-cell-background-info {
                        background-color: $set-info-lighter-color;
                      }
                      &.grid-footer-cell-background-warning {
                        background-color: $set-warning-lighter-color;
                      }
                      &.grid-footer-cell-background-danger {
                        background-color: $set-danger-lighter-color;
                      }
                    }
                  }
                  .vxe-table--fixed-left-wrapper {
                    box-shadow: none;
                    &.scrolling--middle {
                      border-right: 1px solid rgba(0,0,0,.05);
                    }
                  }
                  .vxe-table--fixed-right-wrapper {
                    &.scrolling--middle {
                      border-left: 1px solid rgba(0,0,0,.05);
                      box-shadow: -2px 0 2px rgba(0,0,0,.05);
                    }
                  }
                  .vxe-table--border-line {
                    display: none;
                  }
                  .vxe-table--loading {
                    background-color: rgba(255,255,255,.5);
                  }
                  .grid-data-load-failed {
                    a {
                      margin: 0 4px;
                      text-decoration: none;
                    }
                  }
                }
              }
              & > .grid-footer {
                height: 40px;
                line-height: 40px;
                background-color: #fff;
                .el-pagination {
                  padding: 6px 0;
                  .el-pagination__jump {
                    margin-left: 15px;
                    margin-right: 15px;
                    .el-input {
                      width: auto;
                      .el-input__inner {
                        margin: 2px;
                        width: 40px;
                        height: 24px;
                        font-size: 13px;
                        line-height: 24px;
                      }
                    }
                  }
                  .el-pagination__rightwrapper {
                    .custom {
                      margin-right: 10px;
                      color: #606266;
                      font-size: 13px;
                      font-weight: 400;
                      &.optimize {
                        color: $set-warning-color;
                        i {
                          font-size: 14px;
                        }
                      }
                    }
                    .el-pagination__sizes {
                      margin-right: 1px;
                      .el-select {
                        .el-input {
                          .el-input__inner {
                            margin: 1px 0;
                            height: 26px;
                            line-height: 26px;
                          }
                        }
                      }
                    }
                  }
                  .btn-prev,
                  .btn-next {
                    background-color: transparent;
                  }
                  .el-pager {
                    & > li {
                      font-weight: normal;
                      background-color: transparent;
                    }
                  }
                  @media screen and (max-width:992px) {
                    .el-pagination__jump,
                    .el-pagination__sizes {
                      display: none;
                    }
                    .el-pager {
                      & > li {
                        min-width: 30px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        & > .data-grid-border {
          position: absolute;
        }
        @media screen and (max-width:767px) {
          & > .el-card {
            position: static;
            height: 100%;
          }
          & > .data-grid-border {
            display: none;
          }
        }
      }
      .grid-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 5px 12px;
            border-radius: 0;
          }
        }
      }
    }
  }

  .search-input-drop,
  .grid-top-menu-drop {
    min-width: 150px;
    &.is-wide {
      min-width: 240px;
      .drop-menu-body {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }
    .drop-menu-header {
      padding: 5px 15px 10px;
      font-size: 12px;
      color: #303133;
      line-height: 20px;
      border-bottom: 1px solid #ebeef5;
    }
    .drop-menu-body {
      max-height: 200px;
      .el-dropdown-menu__item,
      .menu-config-list {
        padding: 0 15px;
        line-height: 28px;
        .menu-config-item {
          & + .menu-config-item {
            margin-top: 5px;
          }
        }
      }
      .menu-config-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #606266;
        font-size: 12px;
        .option-wrapper {
          margin-left: 30px;
          &.visibility-hidden {
            visibility: hidden;
          }
          .el-radio-group {
            transform: scale(1) translate(0,-1px);
            .el-radio-button {
              & > .el-radio-button__inner {
                padding: 1px 2px;
                border-radius: 0;
                i {
                  margin: 0;
                  font-size: 12px;
                  transform: scale(.8);
                }
              }
            }
          }
        }
        .el-switch {
          transform: scale(.8) translateX(10%);
        }
        .el-radio-group {
          transform: scale(.9) translateX(5%);
          backface-visibility: hidden;
          .el-radio-button {
            & > .el-radio-button__inner {
              padding: 4px 9px;
            }
          }
        }
        .el-button {
          transform: scale(.9) translateX(5%);
          padding: 4px 12px;
        }
      }
    }
    .drop-menu-footer {
      padding: 5px 15px 0;
      font-size: 12px;
      color: #303133;
      text-align: center;
      line-height: 20px;
      border-top: 1px solid #ebeef5;
      .el-button {
        width: 100%;
        padding: 5px 15px;
      }
    }
    .el-checkbox {
      font-size: 12px;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }

  .el-dropdown-menu {
    padding: 5px 0!important;
    .el-dropdown-menu__item {
      &.grid-menu-dropdown-item {
        position: relative;
        min-width: 80px;
        padding: 1px 12px 1px 10px;
        font-size: 12px;
        &.is-disabled {
          opacity: .6;
          cursor: not-allowed;
          pointer-events: auto;
        }
        i {
          margin-right: 1px;
          font-size: 16px;
          vertical-align: -1px;
          transform: scale(.85);
        }
        & + .el-dropdown-menu__item {
          margin-top: 1px;
          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: -1px;
            right: 0;
            height: 1px;
            background-color: rgba(0,0,0,.05);
          }
        }
      }
    }
  }
</style>
